import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../services/profile.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResultService } from '../services/result.service';
import { filter } from 'rxjs/operators';
import { CompanyDetailsService } from '../services/company-details.service';
import { UserService } from '../services/user.service';
import { LoaderService } from '../services/loader.service';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-registration-history',
  templateUrl: './registration-history.component.html',
  styleUrls: ['./registration-history.component.css']
})
export class RegistrationHistoryComponent implements OnInit {

  constructor(private _profileService : ProfileService,private spinner: NgxSpinnerService,
              private _resultService : ResultService,private _companyDetailsService : CompanyDetailsService,
              private _userService : UserService, private _loaderService: LoaderService, public log: LogService) { }
  public details = [];
  public sessions = [];
  public semester_alias = [];
  public semesters = [];
  public tabs = [];
  public reg;
  public totalRegUnits = 0
  public data;
  public currentSemester;
  public sessionYear;
  public totalUnits = 0;
  public company_initial;
  public company_logo;
  public company_name;
  public company_address;
  public studentPassport;
  public firstname;
  public lastname;
  public middlename;
  public student_id;
  public cd_id;
  public session_year;
  public semester;
  public studentLevel;
  public dept;
  public isFullyLoaded;
  public matric_no;

  public program;

  watchProgram(){
    this._userService.programChange.subscribe(data => {
      this.ngOnInit(1);
    })
  }

  ngOnInit(time = 0) {
    this.log
      .addLog({
      action: "Access",
      component: "Registration History",
      details: `Accessed Registration History`,
    }).subscribe(data => { });
    if(time == 0){
      this.watchProgram()
    }
    this._loaderService.emitChange(true);
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    //this.details = this._profileService.getCourseDetails();
    this._resultService.regHistory().subscribe(data=>{
      // console.log(data, "HISTORY");
      this.data = data;

      this.details.length = 0;
      this.tabs.length = 0;
      this.sessions.length = 0;
      this.semesters.length = 0;
      this.semester_alias.length = 0;
      for(let i in data){
        if(this.sessions.indexOf(data[i].session_year) <= -1){
          this.sessions.push(data[i].session_year);
        }
        if(this.semesters.indexOf(data[i].term) <= -1){
          this.semesters.push(data[i].term);
          this.semester_alias.push(data[i].term.charAt(0));
        }
      }
      
      for(let i in this.sessions){
        for(let j in this.semesters){
          this.details.push(data.filter(x => x.session_year == this.sessions[i]
          && x.term == this.semesters[j]));
          
        }
      }
      //console.log("details: ", this.details);

      //display tabs
      for(let i in this.sessions){
        for(let j in this.semester_alias){
          this.tabs.push(this.sessions[i]+"|"+this.semester_alias[j]);
        }
      }
      this._loaderService.emitChange(false);
    })

    this._companyDetailsService.getDetails().subscribe(data =>{
      this.company_initial = data.adm_initial;
      this.company_logo = data.logo;
      this.company_name = data.name;
      this.company_address = data.address;
    });

    this._userService.getUserData().subscribe(data => {
      // console.log(data, "USER DATA");
      this.matric_no = data.matric_no
      this.currentSemester = data.term;
      this.sessionYear = data.session_year;
      this.cd_id = data.cd_id;
      this.studentPassport = data.passport;
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.middlename = data.middlename;
      this.student_id = data.student_id;
      this.studentLevel = data.tag;
      if(this.company_initial == 'NBTS'){
        this.dept = data.description;
      }else{
        this.dept = data.cat_description;
      }
      this.program = data.name;
    });

  }

  currentTab(event){
    let selectedTab = event.tab.textLabel;
    let session = selectedTab.split('|')[0];
    let semester = selectedTab.split('|')[1];
    if(semester == "F"){
      semester = "First Semester";
    }else if(semester == "S"){
      semester = "Second Semester";
    }
    this.reg = this.data.filter(x => x.session_year == session && x.term == semester);
    this.totalRegUnits = this.reg.reduce((accumulator,reg)=>{return accumulator+reg.unit}, 0);
    this.session_year = session;
    this.semester = semester;
  }



  print(){
    this.log
      .addLog({
      action: "Access",
      component: "Registration History",
      details: `Printed Registration History`,
    }).subscribe(data => { });
    let mywindow = window.open('', 'PRINT', 'height=700,width=1000');
    mywindow.document.write('<html><head><title>' + document.title  + '</title>');
    mywindow.document.write(
      "<style>body{font-family:arial;} div{float:left;} table{background-color:#fff;border-collapse:collapse;width:100%;font-family:arial;font-size:0.85em;border:solid 1px #ccc;margin-top:20px;} th, td{border:solid 1px #ccc;padding:8px 5px; text-align:left;} img{width:50px;height:50px} table#summary tr td{padding-top:40px;text-align:center;} .clearfix{clear:both} table,table#details tr td{border:none}</style>"
    );
    mywindow.document.write("</head><body>");
    mywindow.document.write("<div style='width:15%'>")
    mywindow.document.write("<img src='"+this.company_logo+"'>");
    mywindow.document.write("</div>");
  
    mywindow.document.write("<div style='width:85%'>")
    mywindow.document.write("<span><strong>"+this.company_name+"</strong></span><br>");
    mywindow.document.write("<span><small>"+this.company_address+"</small></span>");
    mywindow.document.write("</div>");
    mywindow.document.write("<div style='width:100%'><hr style='color:#ccc'></div>");
    mywindow.document.write("<div class='clearfix'></div>");
  
    mywindow.document.write("<div style='width:70%'>");
    mywindow.document.write(`<table id='details'><tr style="text-transform: uppercase"><td style=width:35%'>Name:</td><td style='width:65%'>${this.lastname} ${this.firstname} ${this.middlename} </td></tr><tr><td style=width:35%'>Dept:</td><td style='width:65%'>${this.dept}</td></tr>`);
    if(this.company_initial == 'ADECOM'){
      mywindow.document.write("<tr><td>Registration Number:</td><td>"+this.matric_no+"</td></tr></table>");
    }else{
      mywindow.document.write("<tr><td>Matric Number:</td><td>"+this.matric_no+"</td></tr></table>");
    }
    mywindow.document.write(`<p>${this.session_year} ${this.semester} COURSE FORM</p>`);
    mywindow.document.write(`<p> <small>Level: ${this.program} - <span style="text-transform: uppercase">${this.studentLevel}</span></small> </p>`);
    mywindow.document.write("</div>");
  
    mywindow.document.write("<div style='width:30%;text-align:right;'>");
    mywindow.document.write("<img style='border-radius:50%;' src='"+this.studentPassport+"'>");
    mywindow.document.write("</div>");
  
    mywindow.document.write(document.getElementById('toBePrinted').innerHTML);
  
    mywindow.document.write("<table id='summary' style='border:none;margin-top:20px'><tr><td style='border:none;width:33.33%'><hr />Student</td><td style='border:none;width:33.33%;'><hr /> HOD</td><td style='border:none;width:33.33%;'><hr />F. Advisor</td></tr><tr><br /><br /><td style='border:none;width:33.33%'><hr />DSA</td><td style='border:none;width:33.33%;'><hr /> Student Body</td><td style='border:none;width:33.33%;'><hr />Bursar</td></tr></table>")
  
    mywindow.document.write('</body></html>');
  
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    // mywindow.close();
  
    return true;
  }


}
